<template>
  <a-row type="flex" class="main-content" align="middle">
    <a-col :span="8">
      <a-steps
        progress-dot
        :current="stepCurrent"
        direction="vertical"
        @change="onStepChange"
      >
        <a-step
          v-for="(item, index) in companyList"
          :key="'company' + index"
          :title="item.name"
          :description="item.jobTitle"
        />
      </a-steps>
    </a-col>
    <a-col :span="16">
      <div class="logo-container">
        <img
          v-for="(item, index) in companyList"
          :key="'logo' + index"
          :src="item.logo.imgSrc"
          v-show="item.logo.display"
        />
      </div>
      <h5>Front End Timekeeper:</h5>
      <ul class="time-keeper-conatiner">
        <li
          v-for="(item, index) in timeKepperContent"
          :key="'time-keeper' + index"
        >
          <div class="time-keeper-untilltime">
            <ICountUp
              :endVal="calcTimeUntil(companyList[stepCurrent], item)"
              :options="options"
            />
          </div>
          <div class="time-keeper-unit">{{ item.unit }}</div>
        </li>
      </ul>
    </a-col>
  </a-row>
</template>
<script>
import logoElephant from "../../assets/img/logo-elephant.svg";
import logoCollaborate from "../../assets/img/logo-collaborate.svg";
import logoMitake from "../../assets/img/logo-mitake.png";
import logoLeonton from "../../assets/img/logo-leonton.svg";
import logoIgnatius from "../../assets/img/logo-ignatius.svg";
import logoMigo from "../../assets/img/logo-migo.svg";
import logoTaishinLife from "../../assets/img/logo-taishihlife.png";

import { intervalToDuration } from "date-fns";

import ICountUp from "vue-countup-v2";
export default {
  name: "fullpageSection3",
  props: [],
  components: { ICountUp },
  data() {
    return {
      companyList: [
        {
          name: "台新人壽保險股份有限公司",
          jobTitle: "專案襄理-資深前端工程師",
          workStart: "2023/4/17",
          workEnd: "",
          logo: {
            imgSrc: logoTaishinLife,
            display: true
          }
        },
        {
          name: "功典資訊股份有限公司",
          jobTitle: "資深前端工程師",
          workStart: "2021/7/5",
          workEnd: "2023/4/14",
          logo: {
            imgSrc: logoMigo,
            display: false
          }
        },
        {
          name: "依納爵科技管理顧問股份有限公司",
          jobTitle: "前端工程師",
          workStart: "2020/4/1 9:00:00",
          workEnd: "2021/3/15 18:00:00",
          logo: {
            imgSrc: logoIgnatius,
            display: false
          }
        },
        {
          name: "連易通科技股份有限公司",
          jobTitle: "前端工程師",
          workStart: "2019/5/27 9:00:00",
          workEnd: "2020/3/31 18:00:00",
          logo: {
            imgSrc: logoLeonton,
            display: false
          }
        },
        {
          name: "三竹資訊股份有限公司",
          jobTitle: "前端工程師",
          workStart: "2018/08/6 9:00:00",
          workEnd: "2019/03/31 18:00:00",
          logo: {
            imgSrc: logoMitake,
            display: false
          }
        },
        {
          name: "科萊博瑞科技股份有限公司",
          jobTitle: "前端工程師",
          workStart: "2016/11/1 9:00:00",
          workEnd: "2018/7/31 18:00:00",
          logo: {
            imgSrc: logoCollaborate,
            display: false
          }
        },
        {
          name: "飛象資訊股份有限公司",
          jobTitle: "網頁美術",
          workStart: "2015/11/1 9:00:00",
          workEnd: "2016/9/1 18:00:00",
          logo: {
            imgSrc: logoElephant,
            display: false
          }
        }
      ],
      timeKepperContent: [
        { timeUntil: 0, unit: "Years" },
        { timeUntil: 0, unit: "Months" },
        { timeUntil: 0, unit: "Days" },
        { timeUntil: 0, unit: "Hours" },
        { timeUntil: 0, unit: "Minutes" },
        { timeUntil: 0, unit: "Seconds" }
      ],
      stepCurrent: 0,
      options: {
        duration: 1,
        useEasing: true,
        useGrouping: true,
        separator: "",
        decimal: ".",
        prefix: "",
        suffix: ""
      }
    };
  },
  methods: {
    //初始化LOGO的顯示
    initLogoDisplay() {
      this.companyList.forEach(item => {
        item.logo.display = false;
      });
    },
    //觸發切換step的事件
    onStepChange(current) {
      this.stepCurrent = current;
      this.initLogoDisplay();
      this.companyList[current].logo.display = true;
    },
    calcTimeUntil(companyItem, timekeeperItem) {
      const timeUntilResult = intervalToDuration({
        start: companyItem.workStart
          ? new Date(companyItem.workStart)
          : new Date(),
        end: companyItem.workEnd ? new Date(companyItem.workEnd) : new Date()
      });
      this.timeKepperContent.forEach((timeKepperItem, timeKepperIndex) => {
        const key = timeKepperItem.unit.toLowerCase();
        this.timeKepperContent[timeKepperIndex].timeUntil =
          timeUntilResult[key];
      });
      return timekeeperItem.timeUntil;
    }
  }
};
</script>
<style lang="scss">
@import "../../css/variable.scss";

.ant-steps-item-content {
  .ant-steps-item-title {
    font-weight: bold;
  }
}

.ant-steps-item-finish {
  > .ant-steps-item-container {
    > .ant-steps-item-tail::after {
      background-color: $border-color;
    }
  }
}
.logo-container {
  text-align: center;

  > img {
    width: 100%;
    max-width: 300px;
    margin-bottom: 3vw;
  }
  + h5 {
    width: 95%;
    margin: 10px auto;
    font-size: 1.5rem;
    color: $font-color-light-gray;
  }
}
.time-keeper-conatiner {
  background-color: #38639e;
  border-radius: 4px;
  color: #fff;
  display: flex;
  margin-bottom: 0;
  padding: 0.5rem;
  width: 95%;
  margin: 0 auto;

  > li {
    text-align: center;
    padding: 0.5rem;
    border-right: 1px solid #ffffff4a;
    width: calc(100% / 6);

    &:last-of-type {
      border: 0;
    }
    .time-keeper-untilltime {
      font-size: 1.8rem;
      margin-bottom: 5px;
    }
    .time-keeper-unit {
      font-size: 1rem;
    }
  }
}

@media screen and(max-width:1280px) {
  .logo-container {
    > img {
      max-width: 200px;
    }
  }
}
</style>
